/* eslint-disable no-undef */
/* eslint-disable import/extensions */
import { call, put, takeEvery } from "redux-saga/effects";
import {
	ActionsListCategory,
	failureListCategory,
	loadGetListCategory,
	loadListCategorySuccess,
} from "./actions";

function* loadDataListCategory(params = {}) {
	try {
		yield put(loadGetListCategory());

		const endpoint = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/category`;
		const headers = params.payload.headers
		const method = "GET";
		const options = { headers, method };

		const response = yield call(fetch, endpoint, options);
		if (response.status >= 200 && response.status < 300) {
			const data = yield response.json();

			yield put(loadListCategorySuccess(data));
		}
	} catch (err) {
		yield put(failureListCategory(err));
	}
}

export default function* rootSaga() {
	yield takeEvery(ActionsListCategory.GET_LIST_CATEGORY, loadDataListCategory);
}
